/** ``12.3s`` under a minute; ``2m 05s`` under an hour; ``1h 03m``
 * beyond that. ``null`` (fanned node, or not yet dispatched) renders
 * as an em dash.
 *
 * It lives in its own module because it now has TWO consumers that must
 * agree: `RunWorkspace`'s per-Tile duration column, where it started as a
 * private helper, and the run header's elapsed figure (chrome 4/4). The
 * same run's wall time reading `3m 27s` in one place and `3.45 min` in
 * the other is the kind of disagreement a second copy produces
 * eventually and silently — the same reasoning `type-scale.test.ts`
 * applies to the micro-label numbers.
 *
 * `RunHeader` reaches it through `run-header-meta.ts`, which owns the
 * separate question of WHEN a run has an elapsed time worth printing at
 * all; this function only formats a number of seconds it is given. */
export function formatDuration(seconds: number | null): string {
  if (seconds === null) return "—";
  const s = Math.max(0, seconds);
  if (s < 60) return `${s.toFixed(1)}s`;
  const totalSeconds = Math.floor(s);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  if (hours > 0) return `${hours}h ${String(minutes).padStart(2, "0")}m`;
  return `${minutes}m ${String(secs).padStart(2, "0")}s`;
}
